export default __webpack_public_path__ + "static/media/a011-010.c48ffbfa.jpg";